<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <div class="flex items-center -mx-2">
            <div class="px-2">
                <span class="cmp-slider-value" v-html="content"></span>
            </div>
            <div class="flex-grow">
                <app-slidebar
                    :class="options"
                    v-model="content"
                    :data="data"
                    v-bind="$attrs"
                    :processStyle="slider.processStyle"
                    :lineHeight="slider.lineHeight"
                    @input="update()"
                    slot="input"
                >
                    <template slot="tooltip" slot-scope="tooltip">
                        <span class="cmp-slider-tooltip"></span>
                    </template>
                </app-slidebar>
            </div>
        </div>
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    import VueSlideBar from 'vue-slide-bar';

    export default {
        name: 'app-field-text',
        components: {
            'app-field': Field,
            'app-label': Label,
            'app-slidebar': VueSlideBar
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            },
            data: {
                required: false
            }
        },
        data: () => ({
            content: '',
            slider: {
                lineHeight: 10,
                processStyle: {
                    backgroundColor: '#0071BA'
                }
            }
        }),
        mounted() {
            if (this.value) {
                this.content = this.value;
            }
        },
        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },
        methods: {
            update() {
                this.$emit('input', this.content);
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';

    .cmp-slider-value {
        @apply .inline-block .text-grey-darker .text-sm .text-center;

        width: 40px;
    }

    .cmp-slider-tooltip {
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #0071BA;
    }

    .vue-slide-bar-component {
        padding-top: 0 !important;
    }

    .vue-slide-bar-tooltip-container {
        top: 0 !important;
        width: 10px !important;
    }

    .vue-slide-bar-tooltip-top {
        top: -2px !important;
    }

    .vue-slide-bar {
        height: 6px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/fields/inputs/Slider.vue